<template>
  <main class="dashboard-main-content">
    <ProgressBar />
    <Header />
    <slot>
      <router-view />
    </slot>
  </main>
</template>
<script>
import ProgressBar from "./ProgressBar.vue";
import Header from "./Header.vue";

export default {
  name: "Main",

  components: {
    ProgressBar,
    Header
  }
};
</script>
